class DiscountProcessor extends HTMLElement {
    constructor() {
      super();
    }

    static init() {
      DiscountProcessor.collections = ['gloves', 'masks'];
      DiscountProcessor.codes = {
                            '8GDTASKJHA69':
                              ['gloves', '50', 'percent', "?redirect=/collections/all-gloves"],
                            'ZC7AWQ3TZPNW':
                              ['masks', '50', 'percent', "?redirect=/collections/face-masks"]};
      DiscountProcessor.appliedCode = '';
      DiscountProcessor.discounts = [];
    }

    static getDiscount() {
        return DiscountProcessor.codes;
    }

    static getCodes() {
      let codes = DiscountProcessor.codes;
      codes = Object.entries(codes);

      return codes;
    }

    static visitLink(link_type = 'gloves') {
      let codes = DiscountProcessor.getCodes();

      let url = '';
      codes.forEach(el => {
        if(el[1][0] == link_type) {
          url = '/discount/' + el[0] + el[1][3];
          return;
        }
      });

      if(url != '') {
        window.location.href = url;
      } else {
        return url;
      }
    }

    static setDiscount(key, val) {
      DiscountProcessor.discounts[key] = val;
    }

    static getDiscounts(type = 'gloves') {
      if(type == null) {
        return null;
      }

      if(type in DiscountProcessor.discounts) {
        return DiscountProcessor.discounts[type];
      } else {
        return null;
      }
    }

    static processCartItems(selector) {
      let code = DiscountProcessor.appliedCode;
      let allCodes = DiscountProcessor.getCodes();

      let boots = document.querySelector(selector + '[data-collections*="boots"]');
      if(!boots) {
        return;
      }

      allCodes.forEach(item => {
        if(item[0] == code) {
          let el = document.querySelector(selector + '[data-collections*="' + item[1][0] + '"]');
          if(!el) {
            return;
          }
          let total_price = el.closest('.cart-item');
          if(total_price) {
            total_price = total_price.querySelector('.total-price');
            // total_price = total_price.innerHTML.trim();
          }
          let price = el.innerHTML.replace("$", '');
          let collection = item[1][0];
          let discount = DiscountProcessor.getDiscounts(collection);
          if(discount.type == 'percent') {
            let difference = (price * discount.val / 100);
            let total = total_price.innerHTML.trim();

            total = total.replace('$ ', '');
            total = (total - difference).toFixed(2);
            total_price.innerHTML = '$ ' + total;
            price = (price - (price * discount.val / 100));
          } else if (discount.type == 'fixed') {
            let difference = discount.val;
            let total = total_price.innerHTML.trim();

            total = total.replace('$ ', '');
            total = (total - difference).toFixed(2);
            total_price.innerHTML = '$ ' + total;
            price = price - discount.val;
          }
          price = price.toFixed(2);
          el.innerHTML = "<s>" + el.innerHTML + "</s><span>$ " + price + "</span>";
          el.classList.add('multi-price');
        }
      });
    }
  }
  
  customElements.define('dicsount-processor', DiscountProcessor);
  